import React from "react";
import { Row } from "react-bootstrap";
import Ingredient from "./ingredient";

function IngredientsSet(props) {
  return (
    <div className="recipe-info-group">
      <h5>{props.title}</h5>
      <Row>
        {props.ingredientsList.map((x, index) => {
          return (
            <Ingredient key={index} quant={x.quantity} ingred={x.ingredient} />
          );
        })}
      </Row>
    </div>
  );
}

export default IngredientsSet;
